import React, { Component } from "react";
import Table from "./Table";
import { IoIosRocket as InTransitIcon } from "react-icons/io";
import config from "../../../config";
import errorFunctions from "../../../store/errorFunctions";
import moment from "moment";
import referenceLibrary from "../../../store/referenceLibrary";

export default class Tickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      warranties: [],
      data: [],
      statusFilter: "All",
      searchFilter: "",
    };
  }

  formatValueWithCommas = (value) => {
    if (value === "") return value;

    // Split the value into integer and decimal parts (if applicable)
    const parts = value?.toString().split(".");
    let formattedValue = parts && parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (parts?.length > 1) {
      const decimalPart = parts && parts[1].slice(0, 2);
      formattedValue += `.${decimalPart}`;
    }

    return formattedValue;
  };

  filterChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  statusFilterChange = (value) => {
    this.setState({ statusFilter: value });
  };
  retrieveTickets = (id) => {
    this.setState({ loading: true, serviceCenterId: id });
    let url = "";

    if (this.state.page?.next) url = this.state.page.next;
    else if (this.state.page?.previous) url = this.state.page.next;
    else url = config.backendServer + `service_center/${id}/tickets/`;

    this.props
      .protectedFetch(url, "GET", { id }, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({ loading: false, page: res, data: res.results });
        // this.retrieveWarranties(this.props.selectedbrandID);
        // this.retrieveCustomerNotes(id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.retrieveTickets(this.props.serviceCenterId);
  }

  render() {
    let filteredWarranties = [];
    if (!this.state.data) return <div>No ticket</div>;
    if (this.state.searchFilter) {
      this.state.data?.forEach((item) => {
        if (
          item.owner_name.toLowerCase().includes(this.state.searchFilter.toLowerCase()) ||
          item.device_name.toLowerCase().includes(this.state.searchFilter.toLowerCase()) ||
          parseInt(item.id) === parseInt(this.state.searchFilter) ||
          item.ticket_number.toLowerCase().includes(this.state.searchFilter.toLowerCase())
        ) {
          filteredWarranties.push(item);
        }
      });
    } else {
      this.state.data?.map((val) => filteredWarranties.push(val));
    }

    const tableHead = [
      {
        id: "ticket_number",
        label: "ID",

        valueDisplay: (value) => value,
      },
      {
        id: "date_received",
        label: "Date Received",

        defaultSort: "desc",
        valueDisplay: (value) => moment(value).format("DD-MM-YYYY"),
      },
      {
        id: "last_activity_date",
        label: "Last Activity Date",

        valueDisplay: (value) => moment(value).format("DD-MM-YYYY"),
      },
      {
        id: "ticket_type",
        label: "Ticket Type",

        valueDisplay: (value) => value || "(missing)",
      },
      {
        id: "device_name",
        label: "Device Name",

        valueDisplay: (value) => {
          return value.split("-")[1] || value || "(missing)";
        },
      },

      {
        id: "refund_amount",
        label: "Refund Amount",
        width: "50px",

        valueDisplay: (value) => `$ ${this.formatValueWithCommas(value)}`,
      },
      //{id: 'serial_number', label: 'Serial Number', width: '230px', valueDisplay: (value) => value},
      {
        id: "status",
        label: "Status",
        valueDisplay: (value) => {
          const selector = referenceLibrary.statusSelectors.filter((item) => {
            return item.name?.toLocaleLowerCase().includes(value?.toLocaleLowerCase());
          });
          if (selector) {
            return (
              <span
                style={{
                  color: selector.color,
                }}
              >
                {selector.icon}
                <span style={{ fontSize: "0.8em" }}>{value}</span>
              </span>
            );
          } else {
            return (
              <span>
                <InTransitIcon className={"warranties-summary-individual-icon"} />
                <span style={{ fontSize: "0.8em" }}>{value}</span>
              </span>
            );
          }
        },
      },
      {
        id: "assigned_to",
        label: "Assigned To",
        valueDisplay: (value) => value,
      },
    ];

    if (!(this.state.data && this.state.data?.length > 0)) return <div>No ticket</div>;
    return (
      <div>
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          <div className="input-group col-4">
            <input
              type="text"
              placeholder="Search tickets"
              id={"searchFilter"}
              className={"form-control"}
              onChange={this.filterChange}
              value={this.state.searchFilter}
              width={"70px"}
            />
            <div className="input-group-prepend">
              <span className="form-control ">
                <i className="fa fa-search form-control-icon"></i>
              </span>
            </div>
          </div>
        </div>
        <div className={"admin-table-container"}>
          <Table
            head={tableHead}
            data={filteredWarranties}
            reloadMini={this.retrieveWarranties}
            protectedFetch={this.props.protectedFetch}
            selectedbrandID={this.props.selectedbrandID}
            role={this.userRole}
          />
        </div>
      </div>
    );
  }
}
